import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ResultStatus } from "@app/core/models/result-status";
import { WINDOW } from '@app/core/providers/window.provider';
import { AuthenticationService } from "@app/core/services/authentication.service";
import { CommunityService } from "@app/core/services/community.service";
import { HelperService } from "@app/core/services/helper.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import * as _ from "lodash";
@Component({
  selector: "app-trending-posts",
  templateUrl: "./trending-posts.component.html",
  styleUrls: ["./trending-posts.component.scss"],
})
export class TrendingPostsComponent implements OnInit, OnDestroy {
  @ViewChild("shareUrlTemplate") shareUrlTemplate: ElementRef;
  isDataLoaded = false;
  postItemList = [];
  array = [];
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  modalRef: BsModalRef;
  pageNo = 1;
  groupID = 0;
  shareUrl;
  baseShareUrl = "community/post/detail/";

  constructor(
    @Inject(WINDOW) private window: Window,
    private communityService: CommunityService,
    private toaterService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private helperService: HelperService,
    private authService: AuthenticationService
  ) {
    this.activatedRoute.params.subscribe((param) => {
      if (!this.helperService.isUndefinedOrNullOrEmpty(param.groupId)) {
        this.groupID = param.groupId;
      }
    });
  }

  ngOnInit() {
    this.getTrendingPost();
  }

  ngOnDestroy() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  getTrendingPost() {
    this.communityService.getTrendingPots(this.groupID).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.postItemList = result.Data;
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  deleteCommunityPost(id) {
    this.communityService.deleteCommunityPost(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        _.remove(this.postItemList, (currentObject) => {
          return currentObject.ID === +id;
        });
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  like(inputValue) {
    const postData = {
      PostId: inputValue.ID,
      LikedBy: +this.authService.getUserInformation()["ID"],
    };
    if (inputValue.IsLike) {
      this.communityService.likeCommunityPost(postData).subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.getTrendingPost();
        } else {
          this.toaterService.error("something went wrong");
        }
      });
    } else {
      this.communityService
        .deleteCommunityPostLike(inputValue.LikeID)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.getTrendingPost();
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    }
  }

  bookmark(inputValue) {
    const postData = {
      PostId: inputValue.ID,
      BookmarkedBy: +this.authService.getUserInformation()["ID"],
    };
    if (inputValue.IsBookmark) {
      this.communityService
        .bookmarkCommunityPost(postData)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.getTrendingPost();
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    } else {
      this.communityService
        .deleteCommunityPostBookmark(inputValue.BookmarkID)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.getTrendingPost();
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    }
  }

  share(id) {
    this.shareUrl = `${this.window.location.origin}/${this.baseShareUrl}${id}`;
    this.modalRef = this.modalService.show(
      this.shareUrlTemplate,
      Object.assign({}, { class: "modal-md" })
    );
    this.communityService.shareComunityPost(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  approvedRejectPost(value) {
    const postData = {
      PostId: value.PostId,
      Comment: "",
      ResolveBy: +this.authService.getUserInformation()["ID"],
      IsApprove: value.IsApprove,
    };
    this.communityService
      .acceptRejectCommunityPost(postData)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          if (value.IsApprove) {
            this.toaterService.success(`Post is approved successfully`);
            this.postItemList = [];
            this.getTrendingPost();
          } else {
            this.toaterService.success(`Post is rejected successfully`);
            this.postItemList = [];
            this.getTrendingPost();
          }
        }
      });
  }

  updatePost(postId) {
    this.getPostById(postId);
  }

  getPostById(postId) {
    this.communityService.getCommunityPostById(postId).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        const postDetail = result.Data;
        this.postItemList[
          this.postItemList.findIndex((item) => item.ID === postDetail.ID)
        ] = postDetail;
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  reportPost(id) {
    _.remove(this.postItemList, (currentObject) => {
      return currentObject.ID === +id;
    });
  }

  copyToClipboard() {
    document.addEventListener("copy", (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", this.shareUrl);
      e.preventDefault();
      document.removeEventListener("copy", null);
    });
    document.execCommand("copy");

    this.toaterService.info("Link Copied");
    this.modalRef.hide();
  }

  onScrollDown() {
  }
}
